
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import ContactSection from './components/ContactSection';
import { useEffect } from 'react';
import { addSchemaLD, homePageSchema, organizationSchema } from '../../utils/seo';

export default function HomePage() {
  useEffect(() => {
    // Add Schema.org JSON-LD for SEO
    addSchemaLD(homePageSchema);
    addSchemaLD(organizationSchema);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <HeroSection />
        <ServicesSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
